import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { useState, useEffect } from "react";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { purchaseOfferService } from "./purchaseOfferService"
import { IPurchaseOfferSearch, IPurchaseOfferDetail, IPurchaseOfferFields } from "./purchaseOfferType"
import { transPgToPagination, formatNum } from "@/utils/utils";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
export interface IDescTotal {
    totalNum: number,
    totalAmount: number
}
export const usePurchaseOfferModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel()
    const { shopCode, shopId } = shopAndOrg
    //切换站点清除缓存
    useEffect(() => {
        reset();
    }, [shopCode])
    const initSearchParam: IPurchaseOfferSearch = {};
    const initDataSource: IPurchaseOfferDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM };
    const initDesc = {
        totalNum: 0,
        totalAmount: 0
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IPurchaseOfferSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IPurchaseOfferDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IPurchaseOfferFields>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IPurchaseOfferDetail[]>([]);
    const [print, setPrint] = useState<boolean>(false)

    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, totalAmount } = item
            newRowsDescTotal.totalNum += +formatNum(totalNum)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IPurchaseOfferDetail)
    }, [selectedRowKeys, dataSource])

    const updateSearchParam = (updateParam: IPurchaseOfferFields) => {
        // console.log(updateParam)
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const loadData = async (page?: ISearchPage, searchValue: IPurchaseOfferSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        const { retData } = await purchaseOfferService.page(searchParams);
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        // loadTotal(searchParams);
    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await purchaseOfferService.total(searchParams);
        setDescTotal(statistics)
    }
    //导出
    const exportPurchaseOffer = async (searchValue: IPurchaseOfferSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })

        const searchParams = {
            ...searchValue,
            shopId,
            ids: selectedRowKeys,
            "pageNum": 0,
            "pageSize": 0,
        }
        try {
            let result = await purchaseOfferService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }
    return {
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg,
        descTotal,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        exportPurchaseOffer,
        setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset,
        print, setPrint
    }
})